<template>
  <div>
    <div class="modal-container pointer truelandUiModalContainer draggable" v-if="isShowModal" v-drag>
      <!-- <audio id="myAudio" controls></audio> -->
      <!-- <div class="failFiles">
        {{ failFiles }}
      </div> -->

      <div class="record-container" v-loading="loading">
        <div class="record-top">
          <div
            class="record-circle"
            :style="{
              background: recorderState === 'recording' ? '#fff' : 'transparent'
            }"
          ></div>
          <div class="top-scroll-part">
            <div class="marquee-box">
              <marquee width="210" direction="left" align="middle" class="record-file-name">
                {{ audioData['title'] }}
              </marquee>
            </div>
          </div>
          <!-- 签名不存在，但上传未知原因失败的情况下，提供下载 -->
          <div class="downloadBtn" @click="localDownload" v-if="recorderIsEnd && multipartUploadParams.Bucket != ''">
            <i class="el-icon-upload"></i>
          </div>
          <img :src="recordClose" class="record-close" @click="closeRecordModal" alt="" />
        </div>
        <div class="record-bottom">
          <img :src="audioPlayBackground" class="audio-background" v-if="recorderState === 'recording'" />
          <img :src="audioPauseBackground" class="audio-background" v-else />
          <div
            class="common-circle left-circle"
            v-if="recorderState === 'inactive' || recorderState === 'paused'"
            @click="playHandler"
          >
            <img :src="playPic" alt="" />
          </div>
          <div class="common-circle left-circle" v-if="recorderState === 'recording'" @click="pauseHandler">
            <img :src="recordPausePic" alt="" />
          </div>
          <div class="common-circle right-circle" @click="stopHandler">
            <img :src="redCirclePic" alt="" />
          </div>
          <div class="record-status-text-box">
            <span class="record-status-text">{{ recordStatusText }}</span>
          </div>
          <div class="record-time-box">
            <span class="record-time">{{ time }}</span>
          </div>
          <div class="record-progress-box" v-if="typeof audioData.uploadPercent === 'number'">
            <div class="record-progress-current" :style="progressStyle"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 麦克风权限指引弹窗 -->
    <microphone-permission-guide v-model="showPermissionGuide" @close="handlePermissionGuideClose" />
  </div>
</template>

<script>
import playIcon from './icons/svg/play.svg'
import pauseIcon from './icons/svg/pause.svg'
import stopIcon from './icons/svg/stop.svg'
import downloadIcon from './icons/svg/download.svg'
import playPic from './assets/play.png'
import recordPausePic from './assets/pause.png'
import redCirclePic from './assets/red-circle.png'
import scaleDefault from './assets/scale_default.png'
import scaleMove from './assets/scale_move.png'
import fullscreenDefault from './assets/fullscreen_default.png'
import fullscreenMove from './assets/fullscreen_move.png'
import closeDefault from './assets/close_default.png'
import closeMove from './assets/close_move.png'
import stopDefault from './assets/stop_default.png'
import stopMove from './assets/stop_move.png'
import pauseDefault from './assets/pause_default.png'
import pauseMove from './assets/pause_move.png'
import pauseClick from './assets/pause_click.png'
import previousDefault from './assets/previous_default.png'
import previousMove from './assets/previous_move.png'
import nextDefault from './assets/next_default.png'
import nextMove from './assets/next_move.png'
import voiceDefault from './assets/voice_default.png'
import voiceMove from './assets/voice_move.png'
import voiceClick from './assets/voice_click.png'
import downloadDefault from './assets/download_default.png'
import downloadMove from './assets/download_move.png'
import arrowRight from './assets/arrow_right_new.png'
import arrowLeft from './assets/arrow_left_new.png'
import videoPause from './assets/video_pause.png'
import voicePause from './assets/voice_pause.png'
import voicePlay from './assets/voice_play.png'
import voiceIcon from './assets/voice_icon.png'
import videoList from './assets/video_list.png'
import recordCircle from './assets/record_circle.png'
import recordClose from './assets/record_close.png'
import audioPlayBackground from './assets/audio_play_background.png'
import audioPauseBackground from './assets/audio_pause_background.png'

import mixin from '@/components/audioRecorder/mixin/index.js'
import { Api } from '@/api'
import COS from 'cos-js-sdk-v5'
import createFn from '@/utils/log'

import { addLogs } from '@/utils/audioRecorderLogs'
import MicrophonePermissionGuide from './MicrophonePermissionGuide.vue'

export default {
  name: 'AudioRecorder',
  components: {
    MicrophonePermissionGuide
  },
  mixins: [mixin],
  props: {
    /** 录音所需数据 **/
    audioData: {
      type: Object,
      default: () => {}
    },
    /** 控件类型
     * 0-录音，1-播放 **/
    audioType: {
      type: Number,
      default: 0
    },
    /** 音频和视频的资源 **/
    fileList: {
      type: Array,
      default: () => []
    },
    // 播放器的宽度
    playerWidth: {
      type: Number,
      default: 420
    },
    // 播放器的高度
    playerHeight: {
      type: Number,
      default: 276
    }
  },
  data() {
    return {
      draggable: true,
      recordPausePic: recordPausePic, // 录音暂停按钮
      playIcon: playIcon, // 播放按钮
      pauseIcon: pauseIcon, // 暂停按钮
      stopIcon: stopIcon, // 停止按钮
      downloadIcon: downloadIcon, // 下载按钮
      paused: false, // 是否暂停
      finished: false, // 是否结束
      voice: 0, // 声音大小
      DB: 0, // 音谱
      time: '00:00:00',
      isFirst: true, // 是否第一次调用录音
      recorder: {},
      interval: null, // 计时器
      timer: null,
      playPic: playPic, // 录音播放按钮
      redCirclePic: redCirclePic, // 录音右边的红色按钮
      videoPause: videoPause, // 视频暂停图片
      isShowModal: true, // 是否显示当前组件的弹框
      voiceIcon: voiceIcon, // 音频图标
      videoList: videoList, // 视频列表
      recordCircle: recordCircle, // 录音左边的按钮
      recordClose: recordClose, // 录音关闭的按钮
      audioPlayBackground: audioPlayBackground, // 录音播放时候的背景图
      audioPauseBackground: audioPauseBackground, // 录音暂停时候的背景图
      mediaRecorder: null,
      recorderState: 'inactive', //inactive 处于休息状态；recording 录音中；paused 暂停中；
      recordedBlobs: [],
      chunk_index: 0,
      failFiles: [], //失败文件合集
      smallFile: null, //不满上传大小的文件
      recorderIsEnd: false,
      loading: false,
      //intervalTime:5000,
      intervalTime: 100000,
      completeFile:[],
      logs:[],
      showPermissionGuide: false // 是否显示麦克风权限指引弹窗

      // multipartUploadParams: {
      //   Bucket: '',
      //   Region: '',
      //   Key: '',
      //   UploadId: ''
      // },
      // cos: null,
      // Parts: []
    }
  },
  computed: {
    // 上传进度样式
    progressStyle() {
      const percent = this.audioData.uploadPercent || 0
      return {
        width: percent + '%'
      }
    },
    // 录音的时候显示的文字
    recordStatusText() {
      let r = ''
      if (this.recorderState === 'inactive') {
        r = '等待录音'
      } else if (this.recorderState === 'recording') {
        r = '正在录音'
      } else if (this.recorderState === 'paused') {
        r = '暂停录音'
      }
      return r
    }
  },
  watch: {},
  methods: {
    closeRecordModal() {
      this.$confirm('当前正在录音，是否确定关闭？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'info'
      })
        .then(() => {
          this.stopHandler(false)
          this.isShowModal = false
          this.$emit('close')
          this.uploadLogs();
        })
        .catch(() => {})
    },
    stopHandler(state = true) {
      if (this.mediaRecorder) {
        //执行结束上传流程
        this.recorderIsEnd = state
        this.mediaRecorder.stop()
        this.recorderState = 'inactive'
        this.calcTime(false)
        this.time = '00:00:00'
      }
      //判断如果没有成功请求到秘钥，就要谈下载的框
      if(this.multipartUploadParams.Bucket === ''){
        this.$confirm('存在上传失败录音片段，是否手动下载到本地？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info',
          customClass: 'customConfirmDialogClass',
          closeOnClickModal: false
        }).then(()=>{
          this.localDownload();
        }).catch(()=>{
          this.isShowModal = false
          this.$emit('close')
        })
        
      }
      
    },

    playHandler() {
      if (this.mediaRecorder) {
        this.calcTime(true)
        //开始播放
        if (this.recorderState === 'inactive') {
          //this.mediaRecorder.start(100000)
          this.mediaRecorder.start(this.intervalTime)
          this.recorderState = 'recording'
        } else if (this.recorderState === 'paused') {
          this.mediaRecorder.resume()
          this.recorderState = 'recording'
        }
      }
    },
    pauseHandler() {
      if (this.mediaRecorder) {
        this.calcTime(false)
        this.mediaRecorder.pause()
        this.recorderState = 'paused'
      }
    },

    // addLogs(str){
    //   try{
    //     const now = new Date();
    //     const year = now.getFullYear();
    //     const month = now.getMonth() + 1;
    //     const day = now.getDate();
    //     const hours = now.getHours();
    //     const minutes = now.getMinutes();
    //     const seconds = now.getSeconds();
    //     const time = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    //     this.logs.push(`当前时间：${time}，日志内容：${str}`);
    //     const data = {
    //       uploadId: this.multipartUploadParams.UploadId,
    //       relationId: this.$store.state.audio.audioMsg.relationId,
    //       path: this.multipartUploadParams.Key,
    //       region: this.multipartUploadParams.Region,
    //       bucket: this.multipartUploadParams.Bucket,
    //       fileName: this.audioData.title + '.mp3',
    //       logs:JSON.stringify(this.logs)
    //     }
    //     localStorage.setItem('zzp-audioRecorder', JSON.stringify(data));
    //   }catch(err){
    //     console.log(err)
    //   }
    // },

    mediaRecorderInit() {
      // 判断是否在企业微信环境 321929
      const ua = navigator.userAgent.toLowerCase()
      // 本地测试开关：在控制台执行 localStorage.setItem('test_wecom', 'true') 来模拟企业微信环境
      const testWecom = localStorage.getItem('test_wecom') === 'true'
      const isInWeCom = testWecom || ua.indexOf('wxwork') > -1 || ua.indexOf('micromessenger') > -1

      if (isInWeCom) {
        // 企业微信环境下，先检查是否支持录音API
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          this.$message.error('当前企业微信环境不支持录音功能，请使用浏览器打开')
          const err = new Error('企业微信环境不支持getUserMedia')
          const p = createFn(err, 0, {title: '录音：企业微信环境不支持getUserMedia'})
          Api.saveProdLog(p)
          this.isShowModal = false
          this.$emit('close')
          return
        }

        // 尝试快速检测麦克风权限（3秒超时）
        this.loading = true
        const timeoutPromise = new Promise((resolve, reject) => {
          setTimeout(() => {
            reject(new Error('PERMISSION_TIMEOUT'))
          }, 3000)
        })

        const checkPermission = navigator.mediaDevices.getUserMedia({ audio: true })

        Promise.race([checkPermission, timeoutPromise]).then(stream => {
          this.loading = false
          // 检测成功，立即停止流
          stream.getTracks().forEach(track => track.stop())
          // 继续执行原有的录音初始化逻辑
          this.executeRecording()
        }).catch((err) => {
          this.loading = false
          let errorMsg = '无法获取麦克风权限'
          if (err.message === 'PERMISSION_TIMEOUT') {
            errorMsg = '获取麦克风权限超时，请在企业微信设置中开启麦克风权限后重试'
          } else if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
            errorMsg = '麦克风权限被拒绝，请在企业微信设置中开启麦克风权限'
          } else if (err.name === 'NotFoundError') {
            errorMsg = '未找到麦克风设备，请检查设备'
          }

          // 打开麦克风权限指引弹窗
          this.showPermissionGuide = true

          const p = createFn(err, 0, {title: '录音：企业微信环境麦克风权限检测失败', errorMsg: errorMsg})
          Api.saveProdLog(p)
        })
        return
      }

      // 非企业微信环境，执行原有逻辑
      this.executeRecording()
    },
    executeRecording() {
      navigator.mediaDevices.getUserMedia({ audio: {
          echoCancellation: true,
          noiseSuppression: true,
        }
      }).then(stream => {
        this.mediaRecorder = new MediaRecorder(stream)
        this.mediaRecorder.ondataavailable = event => {
          //要放前面，不然异常情况后面会报错
          if(event.data && event.data.size > 0){
            this.completeFile.push(event.data) //先存起来，如果断网或上传异常，提供手动下载的入口
          }
          this.realFileRemediation() //每次触发都检查下失败文件，补救一下
          if (event.data && event.data.size > 0) {
            //每一次都要拼接直接暂存的小文件
            const filename = encodeURIComponent(this.audioData.title + '.mp3')
            const blobs = this.smallFile ? [this.smallFile, event.data] : [event.data]
            
            const file = new Blob(blobs, { type: 'audio/mpeg' })
            console.log(file.size)
            //const file = this.createTestBlob()
            //最后一片可以是小文件
            if (file.size < 1048576 && !this.recorderIsEnd) {
              //if (file.size < 160000 && !this.recorderIsEnd) {
              //小片粘合后，还是不满足上传大小，就再存起来
              this.smallFile = file
              addLogs(`当前是第${this.chunk_index + 1}片，文件大小：${file.size}，文件太小了，不满足上传大小，先存起来。`,this);
            } else {
              //满足大小了，就上传掉
              this.smallFile = null
              //把ebmljs转过的Blob 传下去
              this.ondataavailable(file)
            }
          }
        }

        this.mediaRecorder.onerror = event => {
          //271507
          try{ 
            if(event.error){
              const p = createFn(event.error,0,{title:"录音：mediaRecorder对象，onerror触发"});
              Api.saveProdLog(p)
            }
          }catch(error) {}
        }

        //初始化就要开始录音
        this.playHandler()
      }).catch((err)=>{
        //271507
        if(err.message ){
          if(err.message.indexOf('Permission denied') > -1){
            // 打开麦克风权限指引弹窗
            this.showPermissionGuide = true
          }
          else if(err.message.indexOf('Requested device not found') > -1){
            this.$message.error('没有麦克风设备，请检查。')
          }
        }
        if(err){
          const p = createFn(err,0,{title:"录音：初始化getUserMedia报错，应该是没有麦克风权限，或者干脆没有麦克风"});
          Api.saveProdLog(p)
        }

      })
    },
    calcTime(flag) {
      const timeStr = this.time.split(':')
      let hour = parseInt(timeStr[0])
      let minute = parseInt(timeStr[1])
      let second = parseInt(timeStr[2]) //时 分 秒
      let hourTxt = ''
      let minuteTxt = ''
      let secondTxt = ''
      if (flag) {
        this.interval = setInterval(() => {
          second++
          if (second >= 60) {
            second = 0
            minute = minute + 1
            secondTxt = '0' + second
          } else if (second < 10) {
            secondTxt = '0' + second
          } else {
            secondTxt = second
          }

          if (minute >= 60) {
            minute = 0
            hour = hour + 1
            minuteTxt = minute
          } else if (minute < 10) {
            minuteTxt = '0' + minute
          } else {
            minuteTxt = minute
          }
          if (hour < 10) hourTxt = '0' + hour
          this.time = hourTxt + ':' + minuteTxt + ':' + secondTxt
        }, 1000)
      } else {
        clearInterval(this.interval)
      }
    },
    ondataavailable(blob) {
      this.chunk_index = this.chunk_index + 1
      const file = new window.File([blob], this.audioData.title + '.mp3', { type: 'audio/mpeg' })
      //getSeekableBlob(blobFile,  (file) => {
      const recorderObj = {
        PartNumber: this.chunk_index,
        Body: file
      }
      this.failFiles.push(recorderObj) //先存起来，上传成功再清除掉
      
      console.log('准备上传', this.chunk_index, file)

      // this.cos.sliceUploadFile(
      //     {
      //       ...this.multipartUploadParams,
      //       Body: file, // 上传文件对象
      //       onTaskReady: function(taskId) {
      //         /* 非必须 */
      //         console.log(taskId)
      //       },
      //       onHashProgress: function(progressData) {
      //         /* 非必须 */
      //         // console.log(JSON.stringify(progressData), '2')
      //       },
      //       onProgress: function(progressData) {
      //         console.log('当前进度：', parseInt(String(progressData.percent * 100)))
      //         that.audioData.uploadPercent = parseInt(String(progressData.percent * 100))
      //         /* 非必须 */
      //         // console.log(JSON.stringify(progressData), '3')
      //       }
      //     },
      //     (err, data) => {
      //       console.log(err, data)
      //     }
      //   )
      addLogs(`当前是第${this.chunk_index}片，参数准备好了，即将上传。`,this);
      
      //上传分块
      this.cos.multipartUpload(
        {
          ...this.multipartUploadParams,
          PartNumber: this.chunk_index,
          Body: file
        },
        (err, data) => {
          console.log(err, data)
          if (data && data.statusCode == 200) {
            if (this.chunk_index == 1) {
              //等第一片上傳完成再绑定关系
              this.uploadFileRecord()
            } else {
              //这里是个优化，保证了如果第一次绑定失败了，后面每次都绑定一下，接口支持绑定就不重绑。由于是后期加的优化，我不想再调整流程了，所以在这里直接执行
              this.uploadFileRecord();
              this.uploadCompletedExecuted()
            }
          }

          //271507
          try{
            if(err && err.message){
              const p = createFn(err,0,err.error);
              Api.saveProdLog(p)
            }
            const c1 = err ? JSON.stringify(err) : 'null';
            const c2 = data ? JSON.stringify(data) : 'null';
            addLogs(`当前是第${this.chunk_index}片，已经上传了，结果是，参数err:${c1}，参数data:${c2}`,this);
          }catch(error) {}
        }
      )
      //})
    },

    //分块上传完成要执行的逻辑
    uploadCompletedExecuted() {
      

      //录音上传成功，则要删除掉缓存在failFiles中的数据
      this.removeFiles(this.chunk_index)

      //结束录音，等待最后一个分片上传完成，再提交合并
      if (this.recorderIsEnd) {
        //走完成流程会更新状态1
        this.recorderComplete()
      }
      else{
        //更新进度 0是未完成 1是完成
        this.updateUploadSchedule()
      }
    },

    //和评价表活简历绑定
    uploadFileRecord() {
      Api.uploadFileRecord({
        type: 1,
        uploadId: this.multipartUploadParams.UploadId,
        relationId: this.$store.state.audio.audioMsg.relationId,
        path: this.multipartUploadParams.Key,
        region: this.multipartUploadParams.Region,
        bucket: this.multipartUploadParams.Bucket,
        fileName: encodeURIComponent(this.audioData.title + '.mp3'),
        bizType: 41
      }).then(e => {
        if (e.code == '0' && e.data) {
          this.$store.commit('audio/setAudioListRequest', Math.random())
          this.$store.commit('audio/setAudioId', e.data)
          this.uploadCompletedExecuted();
        }
      }).finally(()=>{
        addLogs(`当前是第${this.chunk_index}片，和评价表活简历绑定完成，接口：/api/zzp-common/upload/uploadFileRecord`,this);
      })
    },

    updateUploadSchedule() {
      Api.updateUploadSchedule({
        uploadId: this.multipartUploadParams.UploadId,
        relationId: this.$store.state.audio.audioMsg.relationId,
        state: 0
      }).finally(()=>{
        addLogs(`当前是第${this.chunk_index}片，要更新当前录音的状态，接口：/api/zzp-common/upload/updateUploadSchedule`,this);
      })
    },
    //真实文件补救措施
    realFileRemediation() {
      if (this.failFiles && this.failFiles.length > 0) {
        const fileData = this.failFiles[0]
        this.cos.multipartUpload(
          {
            ...this.multipartUploadParams,
            PartNumber: fileData.PartNumber,
            Body: fileData.Body
          },
          (err, data) => {
            if (data && data.statusCode == 200) {
              console.log('真实文件补救措施', err)
              // this.Parts.push({
              //   PartNumber: fileData.PartNumber,
              //   ETag: data.ETag
              // })
              //录音上传成功，则要删除掉缓存在failFiles中的数据
              this.removeFiles(fileData.PartNumber)
            }
          }
        )
      }
    },

    removeFiles(i) {
      const index = this.failFiles.findIndex(item => {
        return item.PartNumber == i
      })
      this.failFiles.splice(index, 1)
    },
    //录音完成流程
    recorderComplete() {
      if (this.recorderIsEnd) {
        //先要查已上传的块,如果所有模块都上传齐了，就申请合并，如果不齐，就发起补救
        this.loading = true
        this.multipartListPart()
      }
    },
    varInit() {
      this.chunk_index = 0
      this.failFiles = []

      this.smallFile = null
      this.recorderIsEnd = false
      this.loading = false
    },

    uploadCompleted(data) {
      this.$message.success('录音上传成功')
      this.isShowModal = false
      this.$emit('close')
    },

    multipartInit() {
      this.cosInit()
      this.varInit()
      const filename = encodeURIComponent(this.audioData.title + '.mp3')
      Api.generatorTempSecretId({
        filename,
        type: 1
      }).then(res => {
        if (res.code == '0' && res.data) {
          this.multipartUploadParams.Bucket = res.data.bucket
          this.multipartUploadParams.Region = res.data.region
          this.multipartUploadParams.Key = res.data.path
          this.cos = new COS({
            SecretId: res.data.tmpSecretId,
            SecretKey: res.data.tmpSecretKey,
            XCosSecurityToken: res.data.sessionToken
          })
          Api.generatorUploadId({
            filename,
            relationId: this.$store.state.audio.audioMsg.relationId,
            type: 1,
            path: res.data.path
          }).then(e => {
            if (e.code == '0') {
              this.multipartUploadParams.UploadId = e.data.uploadId
              //this.$store.commit('audio/setAudioListRequest', Math.random())
              //this.$store.commit('audio/setAudioId', e.data.fileId)
            }
          })
        }
      }).catch((err)=>{
        if(err.message && err.message === "Network Error"){
          this.$message.error('网络异常，无法录音，请检查网络。')
        }
      })
    },

    localDownload(){
      const blob = new Blob(this.completeFile, {type: "audio/webm"});
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', this.audioData.title + '.webm');
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      this.$message.success('录音下载成功！')
      this.isShowModal = false
      this.$emit('close')
    },
    handlePermissionGuideClose() {
      // 关闭权限指引弹窗后，也关闭录音组件
      this.isShowModal = false
      this.$emit('close')
    }
  },
  created() {},
  mounted() {
    this.$store.state.audio.logs = [];
    this.uploadLogs();
    this.multipartInit()
    this.mediaRecorderInit()
  },
  filters: {
    /* 整数转换时分秒 */
    formatSecond(second, that) {
      return that.realFormatSecond(second)
    }
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {
    //销毁后也销毁数组
    this.completeFile = [];
  },
  activated() {},
  directives: {
    drag(el) {
      const oDiv = el // 当前元素
      // let self = this // 上下文
      // 禁止选择网页上的文字
      //不能用document去绑定，不然会影响div输入框。
      const container = document.querySelector('.truelandUiModalContainer')
      if (container) {
        container.onselectstart = function () {
          return false
        }
      }

      oDiv.onmousedown = function (e) {
        if (e.target.className.indexOf('el-tooltip el-slider__button') > -1) {
          return
        }
        // 鼠标按下，计算当前元素距离可视区的距离
        const disX = e.clientX - oDiv.offsetLeft
        const disY = e.clientY - oDiv.offsetTop

        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          let l = e.clientX - disX
          let t = e.clientY - disY
          if (l < 0) {
            l = 0
          } else if (l > document.body.clientWidth - oDiv.clientWidth) {
            l = document.body.clientWidth - oDiv.clientWidth
          }
          if (t < 0) {
            t = 0
          } else if (t > document.body.clientHeight - oDiv.clientHeight) {
            t = document.body.clientHeight - oDiv.clientHeight
          }
          // 移动当前元素
          oDiv.style.left = l + 'px'
          oDiv.style.top = t + 'px'
          oDiv.style.width = oDiv.clientWidth + 'px'
          oDiv.style.height = oDiv.clientHeight + 'px'
        }
        document.onmouseup = function (e) {
          document.onmousemove = null
          document.onmouseup = null
        }
        // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.failFiles {
  width: 400px;
  height: 200px;
  position: fixed;
  z-index: 999;
  top: 10px;
  left: 100px;
  background: #fff;
  overflow: auto;
}
.draggable {
  z-index: 9999;
  position: fixed !important;
  right: 0 !important;
  bottom: 60px !important;
}
.truelandUiModalContainer {
  z-index: 9999;
  .slider {
    padding-left: 8px;
    padding-right: 8px;
    .el-slider__button {
      left: 0;
    }
  }
  .record-container {
    width: 306px;
    height: 106px;
    background: #333333;
    border-radius: 24px;
    .record-top {
      width: 100%;
      height: 36px;
      border-radius: 24px 24px 0 0;
      display: flex;
      align-items: center;
      position: relative;
      // .record-circle {
      //   width: 8px;
      //   height: 8px;
      //   margin-left: 24px;
      // }
      .record-circle {
        display: inline-block;
        width: 8px;
        height: 8px;
        border: 1px #4889ff solid;
        margin-left: 20px;
        margin-right: 10px;
        border-radius: 20px;
      }
      .record-close {
        position: absolute;
        right: 24px;
        top: 8px;
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
      .top-scroll-part {
        width: 185px;
        height: 30px;
        left: 74px;
        display: flex;
        align-items: center;
        margin-left: 4px;
        .marquee-box {
          width: 185px;
          overflow: hidden;
          color: white;
          display: flex;
        }
      }
    }
    .record-bottom {
      width: 306px;
      height: 70px;
      background: #333333;
      border-radius: 24px;
      position: relative;
      display: flex;
      .audio-background {
        position: absolute;
        left: 0;
        top: 0;
        width: 306px;
        height: 70px;
        z-index: 0;
      }
      .record-status-text-box {
        width: 100px;
        height: 20px;
        position: absolute;
        top: 6px;
        left: 103px;
        display: flex;
        align-items: center;
        justify-content: center;
        .record-status-text {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #f9f8ff;
        }
      }
      .record-time-box {
        width: 100px;
        height: 16px;
        position: absolute;
        top: 39px;
        left: 103px;
        display: flex;
        align-items: center;
        justify-content: center;
        .record-time {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #fff;
        }
      }
      .record-progress-box {
        width: 170px;
        height: 2px;
        background: #a2a7b2;
        border-radius: 2px;
        position: absolute;
        left: 68px;
        top: 57px;
        .record-progress-current {
          height: 2px;
          background: #4889ff;
          border-radius: 2px;
        }
      }
      .common-circle {
        width: 46px;
        height: 46px;
        border-radius: 100%;
        position: absolute;
        top: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img {
          width: 46px;
        }
      }
      .left-circle {
        left: 13px;
      }
      .right-circle {
        right: 13px;
      }
    }
    .record-file-name {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #f9f8ff;
    }
  }
  .audio,
  .player {
    display: flex;
    align-items: center;
    height: 100%;
    overflow: hidden;
    margin-left: 10px;
    margin-right: 10px;
    width: 320px;
  }

  .loader {
    border: 2px solid #ffffff;
    border-radius: 50%;
    border-top: 2px solid #4889ff;
    width: 10px;
    height: 10px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .download-btn-position {
    position: absolute;
    right: 16px;
  }
}

.pointer {
  cursor: pointer;
}
.play-enter-active,
.play-leave-active {
  transition: opacity 0.3s ease;
}
.play-enter,
.fade-leave-to {
  opacity: 0;
}
.downloadBtn{
  color: #fff;
  margin-left: 10px;
  i{
      transform: rotate(180deg);
  }
}
</style>
